export const isDetailShown = (state, getters) => state.showDetail
export const getDetail = (state, getters) => state.detail
export const isSidebarShown = (state, getters) => state.sidebarStatus
export const getModalFetch = (state, getters) => state.modalFetch
